import {MessageEditor} from "./MessageEditor.js";
import {ChatUI} from "./ChatUI.js";
import {chatClientState} from "./ChatClientState.js";
import {skin} from "../utils/Skin.js";
import typingDots from "./TypingDots.js";
import {initPreview} from "../utils/WebPreview.ts";
import {Chats} from "./Chats.js";

export class Messages extends ChatUI {

	/**
	 * @param {ChatClient} client - parent client
	 * @param {jQuery} header
	 * @param {jQuery} main - element which will be container of the widget
	 * @param {jQuery} footer
	 * @param {string} me - ID of the current user
	 * @param {SharedContext} context - page context
	 */
	constructor(client, header, main, footer, me, context) {
		super();
		this.client = client;
		this.header = header;
		this.container = main;
		this.footer = footer;
		this.me = me;
		this.chatId = null;
		this.context = context;
		this.newMessagesWhenHidden = 0;
		this.install();
	}

	install() {
		this.messagesContainer = $("<div class='chat-messages'></div>");
		this.container.append(this.messagesContainer);

		this.messagesControls =$("<div class='chat-controls'></div>");
		this.footer.append(this.messagesControls);

		this.onlineIndicators = $("<span class='chat-header-online'></span>");
		this.header.append(this.onlineIndicators);

		this.headerTitle = $("<span class='chat-header-title'></span>");
		this.header.append(this.headerTitle);

		this.messageEditor = new MessageEditor(this.messagesControls, this.me, this.send.bind(this), this.context);
	}

	send(msg) {
		this.fireEvent("send", { message: msg});
		return new Promise(((resolve, reject) => {
			const d = JSON.stringify(msg);
			$.ajax("api/messaging/chats/"+this.chatId, {
				type: "POST",
				contentType: "application/json",
				data: d
			}).done(function(data) {
				resolve(data);
			}).fail(function(data) {
				reject(data);
			});
		}));
	}

	/**
	 * All messages in this chat was seen
	 */
	markSeen() {
		this.newMessagesWhenHidden = 0;
		$.getJSON("api/messaging/chats/"+this.chatId+"/seen")
			.done((data) => {
				this.processUnseenData(data);
			})
			.fail((data)=>{
				console.log("Error marking chat "+this.chatId+" seen: "+JSON.stringify(data));
			});
	}

	processUnseenData(data) {
		let total = 0;
		for (let u of data) {
			total += u.unseen;
			let chid = u.chat;
			chatClientState.setUnseen(chid, u.unseen);
		}
		this.client.unseen = total;
	}

	nameFromChatObj(ch) {
		if (ch.topic) return ch.topic;
		for (let d of ch.debaters) {
			if (this.me !== d.nick) return d.name;
		}
		return "-";
	}

	showChat(chatId) {
		this.obtainChatData(chatId)
			.then(function(d) {
				this.messagesContainer.empty();
				for (let msg of d.messages) {
					this.messagesContainer.append(this.msgDataToDOM(msg));
				}
				initPreview(this.messagesContainer);
				this.chatId = chatId;
				this.scrollMessageContainer(false);
				this.messageEditor.showChat(this.chatId);

				const n = this.nameFromChatObj(d);
				this.headerTitle.text(n);
				// create indicators
				this.onlineIndicators.empty();
				let onlyOnline
				for (let deb of d.debaters) {
					if (deb.nick === this.me) continue;
					const bullet = $("<span>&bull;</span>");
					bullet.attr("data-avatar", deb.nick);
					bullet.addClass("chat-ind");
					bullet.addClass("chat-state-" + deb.state);
					bullet.attr("title", deb.name);
					this.onlineIndicators.append(bullet);
				}
				if (Array.isArray(d.unseen)) {
					this.processUnseenData(d.unseen);
				}
			}.bind(this))
			.catch(function(err) {
				console.log("Firing close "+err);
				this.fireEvent("close", {});	// close this message window.
			}.bind(this));
	}

	msgDataToDOM(msg) {
		const msgRoot = $("<div class='chat-message'></div>");
		msgRoot.addClass(this.me === msg.from ? "chat-my" : "chat-their");

		const avatar = $("<img src='avatar/"+msg.from+"' class='chat-message-avatar'>");
		msgRoot.append(avatar);

		const bubbles = $("<div class='chat-message-bubbles'></div>");
		for (let b of msg.media) {
			const bubble = $("<div class='chat-bubble'></div>");
			bubbles.append(bubble);
			if ("text/html" === b.mime) bubble.html(b.text);
			else if ("application/json" === b.mime) this.appendJson(bubble, JSON.parse(b.text));
			else {
				bubble.text(b.text);
				if (Messages.isSingleChar(b.text)) bubble.addClass("single-char");
			}
		}
		msgRoot.append(bubbles);
		if (msg.when) { // formatted date
			const when = $("<div class='chat-when'></div>");
			when.text(msg.when);
			msgRoot.append(when);
		}
		return msgRoot;
	}

	/**
	 * @param {jQuery} bubble - element
	 * @param {SharedContext} context
	 */
	appendJson(bubble, context) {
		if (!context.hasOwnProperty("type") || context.type === 'context') {
			bubble.addClass("chat-context");
			const titleRow = $("<div class='chat-context-title-row'></div>");
			if (context.icon && context.icon.indexOf(".jsp") > 0) {
				const icn = $("<img src='"+skin.i(context.icon, "#FFFFFF")+"' class='icn'>");
				titleRow.append(icn);
			}
			const titleLink = $("<a class='chat-context-title-link'></a>");
			titleLink.attr("href", context.url);
			titleLink.text(context.title);
			if (context.icon && context.icon.indexOf(".jsp") < 0) {
				const icn = Icon.fi(context.icon, null, "margin-right:4px");	// Font icon
				titleLink.prepend(icn);
			}
			titleRow.append(titleLink);
			bubble.append(titleRow);
			if (context.info) {
				const infoRow = $("<div class='chat-context-info'></div>");
				infoRow.text(context.info);
				bubble.append(infoRow);
			}
		}
	}

	typingBubble(from) {
		const msgRoot = $("<div class='chat-message chat-typing' data-typing='"+from+"'></div>");
		msgRoot.addClass(this.me === from ? "chat-my" : "chat-their");

		const avatar = $("<img src='avatar/"+from+"' class='chat-message-avatar'>");
		msgRoot.append(avatar);

		const bubbles = $("<div class='chat-message-bubbles'></div>");
		const bubble = $("<div class='chat-bubble'></div>");
		bubble.append(typingDots(false));
		bubbles.append(bubble);
		msgRoot.append(bubbles);
		return msgRoot;
	}

	static isSingleChar(txt) {
		let count = 0;
		for (let ch of txt) {	// must be this way to handle code points of emojis
			count++;
			if (count > 1) return false;
		}
		return true;
	}

	/**
	 * @param chatId
	 * @return {Promise}
	 */
	obtainChatData(chatId) {

		return new Promise(function(resolve, reject) {
			const d = chatClientState.data;
			if (d == null) {
				$.getJSON("api/messaging/chats/"+chatId)
					.done((data) => {
						resolve(data); // Data contain "unseen" property with array of all unseen chats [{ chatId: "", unseen: count }, ...]
						chatClientState.data = data;
					})
					.fail((data)=>{
						console.log("Error getting chat data "+chatId+": "+JSON.stringify(data));
						reject(data);
					});
			} else {
				resolve(d);
			}
		});
	}

	newMessageInChat(chatId, msg) {
		super.newMessageInChat(chatId, msg);
		if (chatId === this.chatId) {
			this.typingEnded(chatId, {from:msg.from});
			const msgElement = this.msgDataToDOM(msg);
			this.messagesContainer.append(msgElement);
			initPreview(msgElement);
			const data = chatClientState.data;
			if (data != null) {
				data.messages.push(msg);
				chatClientState.data = data;
			}
			this.scrollMessageContainer(true);
			if (msg.from !== this.me) {
				if (document.visibilityState !== "visible") {
					this.client.unseen++;
					chatClientState.setUnseen(chatId, chatClientState.getUnseen(chatId)+1);
					this.newMessagesWhenHidden++;
				} else {
					this.markSeen(); // visible
				}
			}
		} else {
			// Different chat. Just increase unseen count
			if (msg.from !== this.me) {
				this.client.unseen++;
				chatClientState.setUnseen(chatId, chatClientState.getUnseen(chatId) + 1);
			}
		}
	}


	visible(vis) {
		super.visible(vis);
		if (vis && this.newMessagesWhenHidden > 0) {
			// There are some unseen messages and the window was just brought to view
			this.markSeen();
		}
	}

	scrollMessageContainer(animate) {
		const mc = this.container.get(0);
		if (mc.scrollHeight > mc.clientHeight) {
			mc.scrollTop = mc.scrollHeight - mc.clientHeight;
		}
	}

	typingStarted(chatId, data) {
		super.typingStarted(chatId, data);
		if (chatId === this.chatId) {
			const from = data.from;
			const existing = this.messagesContainer.find("[data-typing=" + from + "]");
			if (existing.length === 0) {
				const domMsg = this.typingBubble(from);
				this.messagesContainer.append(domMsg);
				this.scrollMessageContainer(true);
			}
		}
	}

	typingEnded(chatId, data) {
		super.typingEnded(chatId, data);
		if (chatId === this.chatId) {
			const from = data.from;
			this.messagesContainer.find("[data-typing=" + from + "]").remove();
		}
	}

	debaterStateChanged(handle, state) {
		super.debaterStateChanged(handle, state);

		const data = chatClientState.data;
		if (data != null) {
			let wasChange = false;
			for (let db of data.debaters) {
				if (db.nick === handle) {
					if (db.state !== state) {
						db.state = state;
						wasChange = true;
					}
					break;
				}
			}
			if (wasChange) {
				Chats.setStateClass(this.onlineIndicators, handle, state);
				chatClientState.data = data;
			}
		}
	}

}